export default __webpack_public_path__ + "daee8c8ea5585452a70547eab9ada4e8.png";